import React, { Component } from 'react';

class Loading extends Component {
    constructor(){
        super();
        this.state = {
            value: "",
        }
    }
    componentDidUpdate() {
        // console.log("componentDidUpdate");
    }

    componentDidMount() {
        // console.log("componentDidMount");
    }

    componentWillUnmount() {
        // console.log("componentWillUnmount");
    }

    render() {
        return (
            <div className="content">
            </div>
        );
    }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js